import styled from '@emotion/styled';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const LinkWrapper = styled.div`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.link};
  display: block;
  &:hover {
    cursor: pointer;
  }
`;
